/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Card,
  CardContent,
  CardDescription,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@repo/ui";
import Layout from "components/layout";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HoldingPackages from "./holdingPackages";
import InterBranchPackages from "./interBranchPackages";
import PartialPackages from "./partialPackages";
import PendingPackages from "./pendingPackages";

export default function ReRoutingPackageVerification() {
  const [operationType, setOperationType] = useState("holding");

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>
              Re-Routing of Holding/Pending packages
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mt-3 mx-4">
        <CardContent>
          <CardDescription className="pt-6">
            <Tabs value={operationType} onValueChange={setOperationType}>
              <TabsList className="flex w-full max-w-max">
                <TabsTrigger className="flex-1" value="holding">
                  Holding Deliveries
                </TabsTrigger>
                <TabsTrigger className="flex-1" value="partial">
                  Partial Deliveries
                </TabsTrigger>
                <TabsTrigger className="flex-1" value="pending">
                  Pending Deliveries
                </TabsTrigger>
                <TabsTrigger className="flex-1" value="interbranch">
                  Interbranch Deliveries
                </TabsTrigger>
              </TabsList>
              <div className="border-b my-3 bg-accent" />
              <TabsContent value="holding">
                <HoldingPackages />
              </TabsContent>
              <TabsContent value="partial">
                <PartialPackages />
              </TabsContent>
              <TabsContent value="pending">
                <PendingPackages />
              </TabsContent>
              <TabsContent value="interbranch">
                <InterBranchPackages />
              </TabsContent>
            </Tabs>
          </CardDescription>
        </CardContent>
      </Card>
    </Layout>
  );
}
